import { useState } from "react";

const FloatInput = ({
  label,
  type = "text",
  value,
  onChange,
  maxLength,
  placeholder,
  required,
  disabled,
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const active = focused || (value && value.length > 0);

  return (
    <div className="relative">
      <label
        className={`
          absolute left-3 transition-all duration-200 pointer-events-none z-10 bg-white px-1
          ${active ? "-top-2.5 text-xs text-primaryColor font-medium" : "top-[1rem] text-sm text-gray-400"}
        `}
      >
        {label}
        {required && <span className="text-primaryColor ml-0.5">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        placeholder=""
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        disabled={disabled}
        className={`
          w-full px-4 py-3.5 border-2 rounded-xl outline-none text-sm text-gray-800
          transition-all duration-200
          ${disabled ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200" : "bg-white"}
          ${focused && !disabled ? "border-primaryColor shadow-sm shadow-primaryColor/20" : "border-gray-200"}
        `}
        {...props}
      />
    </div>
  );
};

export default FloatInput;